<template>
  <v-card-title class="dialog-title-bar">
    <div class="dialog-title-bar__title">
      <slot />
    </div>
    <div v-if="$slots.actions" class="dialog-title-bar__actions">
      <slot name="actions" />
    </div>
  </v-card-title>
</template>

<style scoped>
.dialog-title-bar {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 24px 10px;
  min-height: 0;
}

.dialog-title-bar__title {
  min-width: 0;
  flex: 1 1 auto;
}

.dialog-title-bar__actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  flex: 0 0 auto;
}

.dialog-title-bar__actions :deep(.v-btn) {
  min-width: 0 !important;
  width: 36px;
  height: 36px !important;
  padding: 0 !important;
  border-radius: 999px;
  background: transparent !important;
  box-shadow: none !important;
}
</style>
